// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:28
import { ResCommunicationTypes_abstract } from './../../abstract/SagaBase/Objects/ResCommunicationTypes_abstract';
export class ResCommunicationTypes extends ResCommunicationTypes_abstract {}
